import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Skeleton, SkeletonRows } from "../components/Skeleton";

const embedFrom = (url) =>
  /^https?:\/\/music\.apple\.com\//i.test(url || "")
    ? url.replace("//music.apple.com/", "//embed.music.apple.com/")
    : "";

export default function PrevWork() {
  const [credits, setCredits] = useState([]);
  const [url, setUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let done = 0;
    const settle = () => {
      done += 1;
      if (done >= 2) setLoading(false);
    };
    api.get("/credits").then((r) => setCredits(r.data || [])).catch(() => {}).finally(settle);
    api
      .get("/settings")
      .then((r) => setUrl(r.data?.appleMusicUrl || ""))
      .catch(() => setUrl(""))
      .finally(settle);
  }, []);

  const embedSrc = embedFrom(url);

  return (
    <div data-testid="prev-work-page">
      <div className="wrap page-head">
        <p className="label" style={{ color: "var(--orange)" }}>Prev. Work</p>
        <h1 className="disp" style={{ marginTop: 12 }}>
          <span className="misreg" data-text="Made Here">Made Here</span>
        </h1>
      </div>

      <div className="wrap">
        {loading ? (
          <div className="embed-block" data-testid="embed-skeleton">
            <Skeleton h={450} w="100%" style={{ maxWidth: 660 }} />
            <div style={{ marginTop: 20, maxWidth: 260 }}>
              <Skeleton h={14} w="100%" />
            </div>
          </div>
        ) : embedSrc ? (
          <>
          <div className="embed-block" data-testid="embed-block">
            <iframe
              data-testid="embed-iframe"
              title="Balboa Recording Studio playlist"
              allow="autoplay *; encrypted-media *;"
              frameBorder="0"
              height="450"
              style={{ width: "100%", maxWidth: 660, overflow: "hidden", background: "transparent" }}
              sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-storage-access-by-user-activation allow-top-navigation-by-user-activation"
              src={embedSrc}
            />
            <div style={{ marginTop: 20 }}>
              <a
                className="link-arrow"
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="apple-music-full-link"
              >
                Listen in full on Apple Music →
              </a>
            </div>
          </div>
          </>
        ) : (
          <div className="empty" style={{ padding: 64 }} data-testid="apple-music-placeholder">
            — add an Apple Music playlist URL in Admin →
          </div>
        )}
      </div>

      <section className="wrap sec" style={{ marginTop: 72 }} data-testid="credits-section">
        <p className="label" style={{ color: "var(--orange)" }}>Selected Credits</p>
        <div className="tape-row mono" style={{ borderBottom: "1px solid var(--ink)", marginTop: 16, opacity: 0.6 }}>
          <span>Artist</span>
          <span>Album/EP/Track</span>
          <span>Year</span>
        </div>
        {loading ? (
          <div style={{ marginTop: 16 }}>
            <SkeletonRows rows={8} h={48} testid="credits-skeleton" />
          </div>
        ) : credits.length ? (
          credits.map((c) => (
            <div className="tape-row" key={c.id} data-testid={`credit-row-${c.id}`}>
              <span className="disp" style={{ fontSize: 20 }}>{c.artist}</span>
              <span className="mono" style={{ fontSize: 14 }}>
                {c.embedUrl ? (
                  <a href={c.embedUrl} target="_blank" rel="noopener noreferrer" className="link-arrow">
                    {c.track}
                  </a>
                ) : (
                  c.track
                )}
              </span>
              <span className="mono" style={{ fontSize: 14 }}>{c.year}</span>
            </div>
          ))
        ) : (
          <div className="empty" style={{ marginTop: 20 }}>— add credits in Admin —</div>
        )}
      </section>
    </div>
  );
}
